import { Suspense, lazy } from 'react';

import { SizeProp } from '@fortawesome/fontawesome-svg-core';

import type { Icon as IconType } from '@personly/libs-types';
import fa from '@personly/libs-fontawesome';

const FontAwesomeIcon = lazy(() =>
  import('@fortawesome/react-fontawesome').then((m) => ({
    default: m.FontAwesomeIcon,
  }))
);

interface Props {
  fixedWidth?: boolean;
  icon: IconType | undefined;
  size?: string;
  spin?: boolean;
}

const IconView = ({ fixedWidth = false, icon, size, spin = false }: Props) => (
  <Suspense fallback={<div className={`fa-${size}`}>&nbsp;</div>}>
    {icon && (
      <FontAwesomeIcon
        icon={fa[icon.packHandle.toLowerCase()][icon.value]}
        fixedWidth={fixedWidth}
        spin={spin}
        size={size as SizeProp}
      />
    )}
    {!icon && 'X'}
  </Suspense>
);

export default IconView;
